import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, TextField, Snackbar } from "@material-ui/core";

import { withRouter } from "react-router-dom";
import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { Table, DatePicker, Button, Input, Select } from 'antd';

const { Option } = Select;
import axios from 'axios'
import {
  getProductList,
  getAllLableList,
} from "../../actions/subscribe";


const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "110px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      marginTop: "12px",
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    listMessage: {
      paddingLeft: "30px",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {},
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      marginRight: "20px",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "2px !important",
    },
    grayBtn: {
      width: "97px",
      height: "40px",
      marginLeft: "18px !important",
      background: "#fff !important",
      borderRadius: "2px !important",
      border: '1px solid #d9d9d9 !important',
      color: '#0F25D1 !important',
      boxShadow: 'none !important'
    },
    container: {
      paddingTop: "20px",
    },
    list: {
      paddingRight: "16px",
      width: "1px",
    },
    label: {
      marginBottom: "16px",
    },
    labelContainer: {
      position: "sticky",
      top: "80px",
      minHeight: "400px",
      maxHeight: "calc(100vh - 140px)",
      padding: "20px 26px 20px 16px",
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0px 1px 10px 1px rgba(0, 0, 0, 0.05)",
      overflow: "auto",
    },
    labelTitle: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "10px",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
      "& img": {
        width: "21px",
        height: "21px",
        marginRight: "10px",
      },
      "& button": {
        marginLeft: "20px",
        width: "82px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "0",
        borderColor: "#D9D9D9",
        color: "#000",
        fontSize: "14px",
      },
    },
    showBtn: {
      width: "82px",
      height: "32px",
      padding: "0 !important",
      border: "1px solid #d9d9d9 !important",
      borderRadius: "2px",
      backgroundColor: "#fff !important",
      color: "rgba(0, 0, 0, .65) !important",
      fontSize: "14px",
      boxShadow: "none !important",
      "&.first": {
        marginRight: "10px",
      },
    },
    subTitle: {
      display: "flex",
      alignItems: "center",
      height: "22px",
      margin: "12px 0",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
      "& img": {
        marginRight: "3px",
        "&.hide": {
          transform: "rotate(-90deg)",
        },
      },
    },
    tag: {
      height: "22px",
      margin: "0 10px 16px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#0F25D1",
        borderColor: "#0F25D1",
      },
    },
    categoryLine: {
      height: "46px",
      padding: "0 7px",
      borderBottom: "1px dashed #d8d8d8",
      overflow: "hidden",
      "&.show": {
        height: "auto",
      },
    },
    select: {
      width: '100%'
    },
  };
};

class CompetitiveProducts extends Component {
  state = {
    keyword: "",
    baseKeyword: "",
    error: "",
    is_all: 0,
    count: 0,
    userId: "", //用户id
    username: "", //用户名
    dataId: "", //弹框数据id,点击右侧管理收藏按钮时，传空
    openMessage: "",
    errorMessage: "",
    // push: true,
    openModal: false,
    modalTitle: "",
    fileList: [],
    labelList: [],
    labelArr: [],
    showAll: false,
    medical_file: '',
    updateTime: '',
    searchHistoryList: [],
    form: {
      type: "",
      keyword: "",
      searchLabel: undefined,
    },
    defaultForm: { // 默认值
      type: "",
      keyword: "",
      searchLabel: undefined,
    },
    labelObj: { // 筛选项key - label对应关系
      type: '搜索类型',
      keyword: '关键词',
      searchLabel: '信息类型',
    },
    labelListObj: { 
      type: 'searchTypeList',
      searchLabel: 'labelList',
    },
    selectKeys: ['type', 'searchLabel'],
    searchTypeList: [
      {
        ID: '',
        Name: '精确搜索'
      },
      {
        ID: 'all',
        Name: '全文搜索'
      },
    ],
    loading: false,
    data: [],
    columns: [
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 120,
        align: 'center',
        render: (text, row) => {
          return (
            <>
              <Button className={this.props.classes.textBtn} type="text" onClick={() => this.downloadFile(row.base_file.dfs_url, row.base_file.file_name)}>下载</Button>
            </>
          )
        }
      },
      {
        title: '文件类型',
        dataIndex: 'file_category',
        key: 'file_category',
        width: 120,
        render: (text, row) => row.base_file.file_category
      },
      {
        title: '文件名称',
        dataIndex: 'TotalSerialNumber',
        key: 'TotalSerialNumber',
        width: 240,
        render: (text, row) => row.base_file.file_name
      },
      {
        title: '上传日期',
        dataIndex: 'customed_file_publish_date',
        key: 'customed_file_publish_date',
        width: 140,
        render: (text, row) => row.customed_file_publish_date.substring(0, 10)
      },
      {
        title: '竞品公司',
        dataIndex: 'customed_file_competitor_name',
        key: 'customed_file_competitor_name',
        width: 120,
      },
      {
        title: '信息',
        dataIndex: 'customed_file_source',
        key: 'customed_file_source',
        width: 120,
      },
      {
        title: '网页链接',
        dataIndex: 'dfs_url',
        key: 'dfs_url',
        width: 240,
        render: (text, row) => (<a onClick={() => this.previewFile(row.base_file.dfs_url)}>{row.base_file.dfs_url}</a>)
      },
    ],
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    },
    page: {
      page: 1,
      pageSize: 10
    },
  };

  componentDidMount() {
    
    this.getTableHeight()

    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    this.loadMore();
    this.queryLable();
  }

  previewFile = (url) => {
    localStorage.setItem('previewUrl', url);
    const w = window.open("ablut:blank");
    w.location.href = "/preview";
  };

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1560,
        y: height - lineHeight - 211
      }
    })
  }

  downloadFile = (url, fileName) => {
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };
  
  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.loadMore())
  }

  resetForm = () => {
    this.setState({
      form: {
        type: "",
        keyword: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => {
      this.loadMore()
      this.getTableHeight()
    })
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => {
      this.loadMore()
      this.getTableHeight()
    })
  }

  searchForm = () => {
    this.loadMore()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    }, () => { this.getTableHeight() })
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  queryLable = () => {
    const param = {
      lable_category_type: "直观复星-定制文件"
    };
    getAllLableList(param).then((res) => {
      let list = res.results.filter(v => {
        return v.lable_category_name === '信息'
      })
      this.setState({
        labelList: list.length > 0 ? list[0].lables.map(v => {
          return {
            ID: v.lable_content,
            Name: v.lable_content
          }
        }) :[],
      });
    });
  };

  loadMore = () => {
    let is_all = 0
    if (this.state.form.type == "all") {
      is_all = 1
    }
    let search_filters = {}
    if (this.state.form.searchLabel) {
      search_filters = {
        "信息":[this.state.form.searchLabel]
      }
    }
    const param = {
      search_filters: search_filters,
      keyword: this.state.form.keyword,
      is_all: is_all,
      ...this.state.page
    };
    getProductList(param).then((res) => {
      if (res && res.results) {
        let data = res.results
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.count
        this.setState({
          data: data,
          paginationObj: newPaginationObj,
          loading: false
        });
      } else {
        this.setState({
          loading: false
        })
      }
    });
  };

  searchFile = () => {
    this.setState(
      {
        page: 1,
        is_all: 0,
      },
      () => this.loadMore(true)
    );
  };
  searchAllFile = () => {
    this.setState(
      {
        page: 1,
        is_all: 1,
      },
      () => this.loadMore(true)
    );
  };

  // changePush = () => {
  //   this.setState({
  //     push: !this.state.push,
  //   });
  // };


  changeShow = (i) => {
    let show = this.state.labelList[i].showDetail;
    let newLabelList = [].concat(this.state.labelList);
    if (show) {
      newLabelList[i].showDetail = false;
    } else {
      newLabelList[i].showDetail = true;
    }
    let showAll = this.state.showAll;
    let size = newLabelList.filter((v) => {
      return v.showDetail;
    }).length;
    if (size == 0) {
      showAll = false;
    }
    if (size == newLabelList.length) {
      showAll = true;
    }
    this.setState({
      labelList: newLabelList,
      showAll: showAll,
    });
  };

  showAllDetail = () => {
    let newLabelList = [].concat(this.state.labelList);
    newLabelList.forEach((v) => {
      v.showDetail = !this.state.showAll;
    });
    this.setState({
      labelList: newLabelList,
      showAll: !this.state.showAll,
    });
  };

  clearAllFilter = () => {
    this.setState(
      {
        labelArr: [],
        page: 1,
      },
      () => this.loadMore(true)
    );
  };


  //关闭消息弹框
  closeMessage = () => {
    this.setState({
      openMessage: false,
    });
  };

  //回车事件
  onKeyDownchange = (e) => {
    if (e.keyCode == 13) {
      this.searchFile();
    }
  };


  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">搜索类型</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.type}
                onChange={(e) => this.onChangeForm(e, 'type')} 
              >
                {
                  this.state.searchTypeList.map((v, i) => {
                    return (
                      <Option value={v.ID} key={i}>{v.Name}</Option>
                    )
                  })
                }
              </Select>
            </div>
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.keyword}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'keyword')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">信息类型</div>
                <Select
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.searchLabel}
                  onChange={(e) => this.onChangeForm(e, 'searchLabel')} 
                >
                  {
                    this.state.labelList.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
            </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">竞品专区</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                scroll={this.state.scrollObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(CompetitiveProducts));
